"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CampaignBatching = void 0;
class CampaignBatching {
    constructor() {
        this.id = 0;
        this.frequency = '';
        this.jobName = '';
        this.cronTrigger = '';
        this.isSaneHours = true;
        this.orderId = 0;
    }
}
exports.CampaignBatching = CampaignBatching;



//////////////////
// WEBPACK FOOTER
// ./~/rules-config/lib/campaign-batching.js
// module id = 1218
// module chunks = 0